export default __webpack_public_path__ + "static/media/183.78558200.svg";